import { render, staticRenderFns } from "./MonitorWrapper.vue?vue&type=template&id=fed5bf1e&scoped=true"
import script from "./MonitorWrapper.vue?vue&type=script&lang=ts"
export * from "./MonitorWrapper.vue?vue&type=script&lang=ts"
import style0 from "./MonitorWrapper.vue?vue&type=style&index=0&id=fed5bf1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed5bf1e",
  null
  
)

export default component.exports